import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthStateService } from '../app/auth/auth-state.service';

/**
 * Bounces signed-in users with {@code mustChangePassword=true} to the
 * force-change-password page before they can interact with anything else.
 *
 * <p>Apply alongside AuthGuard on every protected route. Skip on /auth,
 * /force-change-password (the page itself — would loop), and /email-confirmed
 * (the email link must work mid-flow).</p>
 *
 * <p>Anonymous navigations are passed through; AuthGuard handles them.</p>
 */
@Injectable({
    providedIn: 'root',
})
export class ForceChangePasswordGuard implements CanLoad, CanActivate {

    constructor(
        private readonly navController: NavController,
        private readonly authStateService: AuthStateService,
    ) {}

    canLoad(): boolean {
        return this.check();
    }

    canActivate(): boolean {
        return this.check();
    }

    private check(): boolean {
        const user = this.authStateService.user();

        // Not signed in → AuthGuard's job, not ours.
        if (!user) {
            return true;
        }

        if (!user.mustChangePassword) {
            return true;
        }

        this.navController.navigateRoot('/force-change-password');
        return false;
    }
}
